var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Navigation, Property 2=Historical Insights"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23562 2.54487C2.812 2.33826 2.30109 2.51418 2.09447 2.9378C2.08618 2.9548 2.07851 2.97193 2.07144 2.98918C2.02727 3.09227 2.00281 3.20581 2.00281 3.32506V16.5203C2.00281 16.8482 2.18778 17.1329 2.45908 17.2758C2.47162 17.2827 2.48439 17.2894 2.4974 17.2957L11.5569 21.7143C11.6907 21.7951 11.8452 21.8383 12.0026 21.8377C12.1601 21.8383 12.3146 21.7951 12.4484 21.7143L21.5079 17.2957C21.5782 17.2614 21.6418 17.2187 21.6978 17.1694C21.881 17.0128 21.9972 16.7801 21.9972 16.5203V3.32506C21.9972 3.20579 21.9727 3.09223 21.9285 2.98913C21.9215 2.9719 21.9138 2.95478 21.9055 2.9378C21.6989 2.51418 21.188 2.33826 20.7644 2.54487L12 6.81954L3.23562 2.54487ZM3.70963 15.9879L11.146 19.6149V8.30204L3.70963 4.67508V15.9879ZM20.2904 15.9905V4.67508L12.8528 8.3026V19.618L20.2904 15.9905Z",
    fill: "#006CB7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.5691ea6416fee70443a53654b66827a2.svg";
export { ForwardRef as ReactComponent };